import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Breadcrumb from "../../../Breadcrumb";
import { useSidebar } from "../common/sidebarContext.js";

function Layout({ children, heading }) {
  const location = useLocation();
  const { isCollapsed, isMobileNavOpen, closeMobileNav } = useSidebar();

  // Define labels for breadcrumb paths
  const breadcrumbLabels = {
    "": "Home",
    overview: "Overview",
    "device-listing": "Device Management",
    "device-detail": "Device Info",
    "device-snmp": "SNMP Device",
    topology: "Device Topology",
    OTAManagement: "OTA Management",
    alarms: "Alerts",
    "system-info": "System Information",
    "user-management": "User Management",
    audits: "Audits",
    floormap: "Floor Map",
    // Add other route fragments as needed
  };

  // Generate breadcrumbs by splitting the path
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Check if on any alarms page
  const isAlarmsPage = pathnames[pathnames.length - 1] === "alarms";
  const isFloormapPage = pathnames[pathnames.length - 1] === "floormap";
  const fromOverview =
    isAlarmsPage && location.state && location.state.fromOverview;

  let breadcrumbs;
  if (fromOverview) {
    // Always show Home > Overview > Alerts if coming from overview
    breadcrumbs = [
      { label: breadcrumbLabels[""], path: "/" },
      { label: breadcrumbLabels["overview"], path: "/overview" },
      { label: breadcrumbLabels["alarms"], path: "/overview/alarms" },
    ];
  } else {
    // Default breadcrumb logic
    breadcrumbs = [
      { label: breadcrumbLabels[""], path: "/" },
      ...pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        return {
          label: breadcrumbLabels[value] || value,
          path: to,
        };
      }),
    ];
  }

  // Hide breadcrumb on /alarms if no location.state (direct nav from sidebar)
  // Completely hide breadcrumb on Alerts page
  const showBreadcrumb = breadcrumbs.length > 1 && !isAlarmsPage && !isFloormapPage;

  return (
    <div className={`app-layout ${isCollapsed ? "sidebar-collapsed" : ""} ${isMobileNavOpen ? "mobile-nav-open" : ""}`}>
      {isMobileNavOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation"
          onClick={closeMobileNav}
        />
      )}
      <div id="layout-wrapper" className={isCollapsed ? "sidebar-collapsed" : ""}>
        <Header heading={heading} />
        <Sidebar />
        <main className={`body-container ${isCollapsed ? "sidebar-collapsed" : ""} ${isFloormapPage ? "is-floormap" : ""}`}>
          {showBreadcrumb && (
            <div className="page-toolbar">
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
          )}
          {children}
          {!isFloormapPage && (
            <div className="copyright-text">
              INC Network Management System &copy; 2026 VVDN. All rights reserved.
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default Layout;
